module.exports = "<span ng-message=\"required\">{{'errors.checkminone' | i18n}}</span>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/app/errors/checkboxerrors.tpl.html
// module id = 925
// module chunks = 12